import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// Import FontAwesome SVG icons (tree-shaken for optimal bundle size)
import { FontAwesomeIcon } from '@/config/icons';

// Import CSS
import './assets/css/main.css'; // Import your custom CSS if you have it
import './assets/css/page-layouts.css'; // Import shared page layout styles
import './assets/css/status-badges.css'; // Import global status badge styles

// Note: SmartSkeleton components are now imported locally in components that need them
// This reduces the initial bundle size by not including them in the global bundle

// Note: VeeValidate is now loaded on-demand using the useValidation composable
// This reduces initial bundle size by ~120 KB by not loading all validation rules upfront
// Components that need validation should import and use:
// import { useValidation } from '@/composables/useValidation'
// const { setupValidation } = useValidation()
// await setupValidation(['required', 'email']) // Load only needed rules

// Configuration for debugging in development mode
if (process.env.NODE_ENV === 'development') {
  console.info('Running in development mode');
  
  // Enable Vue performance tracking in dev tools
  const app_config = {
    performance: true,
    devtools: true,
    productionTip: false
  };
  
  // Make sure dev tools can access Vue
  if (window.__VUE_DEVTOOLS_GLOBAL_HOOK__) {
    window.__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue = app_config;
  }
}

// Initialize Vue app
const app = createApp(App);

// Register global components (only FontAwesome - used everywhere)
app.component('font-awesome-icon', FontAwesomeIcon);

// Register and use plugins
app.use(store);
app.use(router);

// Global error handler
app.config.errorHandler = (err, vm, info) => {
  console.error('Vue Error:', err);
  console.error('Info:', info);
  
  // You could also log to an error tracking service here
  // For example: Sentry, LogRocket, etc.
};

// Global warning handler (development only)
if (process.env.NODE_ENV === 'development') {
  app.config.warnHandler = (msg, vm, trace) => {
    console.warn('Vue Warning:', msg);
    if (trace) console.warn('Trace:', trace);
  };
}

// Mount the app
app.mount('#app');

// Setup auth interceptors for token refresh
// store.dispatch('auth/setupAuthInterceptors');

// Log when app is ready (helpful for debugging)
console.info(`${store.getters.appName} v${store.getters.appVersion} initialized`);